import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';

interface Protocol {
  id: string;
  name: string;
  status: 'active' | 'draft' | 'archived';
  items: Array<{
    id: string;
    type: string;
    name: string;
    dosage?: string;
    frequency?: string;
    notes?: string;
  }>;
  created_at: string;
  updated_at: string;
}

export function useProtocols() {
  return useQuery<{ protocols: Protocol[] }>({
    queryKey: ['mr-protocols'],
    queryFn: () => api.get('/protocols'),
  });
}

export function useCurrentProtocol() {
  return useQuery<{ protocol: Protocol | null }>({
    queryKey: ['mr-current-protocol'],
    queryFn: () => api.get('/protocols/current'),
  });
}

export function useCreateProtocol() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      name: string;
      items?: Array<{
        type: string;
        name: string;
        dosage?: string;
        frequency?: string;
        notes?: string;
      }>;
    }) => api.post<{ protocol: Protocol }>('/protocols', data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mr-protocols'] });
      qc.invalidateQueries({ queryKey: ['mr-current-protocol'] });
    },
  });
}

export function useUpdateProtocol() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: string } & Partial<Protocol>) =>
      api.put<{ protocol: Protocol }>(`/protocols/${id}`, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mr-protocols'] });
      qc.invalidateQueries({ queryKey: ['mr-current-protocol'] });
    },
  });
}
